// ⚠️ AVIS D'EXEMPLE (données fictives) — à remplacer par vos vrais avis clients.
export const reviews = [
  {
    name: "Julien M.",
    car: "Golf 7 GTI",
    text: "Passage au E85 impeccable, plus de 800 € économisés la première année. Travail sérieux et explications claires.",
    rating: 5,
  },
  {
    name: "Sophie L.",
    car: "BMW 320d",
    text: "Reprogrammation diesel au top : couple bien plus présent et conso en baisse sur autoroute. Je recommande.",
    rating: 5,
  },
  {
    name: "Karim B.",
    car: "Audi A3 2.0 TDI",
    text: "Problème d'AdBlue réglé une fois pour toutes. Nicolas est transparent sur ce qui est faisable ou non.",
    rating: 5,
  },
  {
    name: "Thomas R.",
    car: "Mégane 4 RS",
    text: "Stage 1 + pop and bang, la voiture est transformée. Réglage fait selon mes envies, rien à dire.",
    rating: 5,
  },
  {
    name: "Élodie P.",
    car: "Peugeot 308 1.2 PureTech",
    text: "Diagnostic honnête avant tout. Pas de promesse excessive, juste du travail bien fait. Merci !",
    rating: 5,
  },
  {
    name: "Marc D.",
    car: "Porsche Cayenne",
    text: "Cartographie sur mesure réalisée avec soin. Service de proximité rare de nos jours. Paiement en plusieurs fois apprécié.",
    rating: 5,
  },
];
